/**
 * Validation of CNH-11 (Carteira Nacional de Habilitação) driver license number
 *   extremely simplified check after request from RIO Brazil. Only check that string consists of 11 numbers and
 *   does not consist of only duplicates of the same number.
 * @param input
 */
export const cnh11Validation = (input: string): boolean => {
    // only digits allowed
    if (!input.match(/\d{11}/)) {
        return false;
    }
    const elevenDigitsNotAllSame = /^(?!([0-9])\1{10}$)\d{11}$/;

    return elevenDigitsNotAllSame.test(input);
};
